<template>
    <div class="row">
        <snappy-table
            ref="table"
            :endpoint="'vessels/'+vesselId+'/audiences/'+groupId+'/contacts'"
            :columns="['status','email','first_name','last_name','reason_for_unsubscribe','created_at', 'actions']"
            :headings="['Status','Email','First Name','Last Name','Status','Created', 'Actions']"
            :template-methods="columnTemplates(timezone)"
            :templated-slot-names="['status', 'reason_for_unsubscribe', 'actions']"
            table-class="subscribers-table"
            :filter-values="filterValues"
            :filterable-columns="['status','email','first_name','last_name']"
            :click-to-toggle-params="clickToToggleParams"
            record-type="Contacts"
        >
            <template #status="{ row }">
                <div @click="handleGroupMemberships(row)" v-if="row.status === 'member'"
                     :class="'subscription-label subscribed label hoverable label-default label-'+ row.id"
                     data-test="leave-group-button">
                    <div class="place-holder subscribed">
                        <i class="icon fas fa-check" aria-hidden="true"></i> MEMBER
                    </div>
                    <div class="action-wrapper unsubscribe-action">
                        <i class="icon fas fa-times" aria-hidden="true"></i> REMOVE
                    </div>
                </div>
                <div v-else @click="handleGroupMemberships(row)"
                     :class="'subscription-label label label-default hoverable label-' + row.id"
                     data-test="join-group-button">
                    <div class="place-holder subscribe-neutral"><i class="icon fas fa-plus" aria-hidden="true"></i>
                    </div>
                    <div class="action-wrapper subscribe-neutral">
                        <i class="icon fas fa-check" aria-hidden="true"></i> JOIN
                    </div>
                </div>
            </template>
            <template #reason_for_unsubscribe="{ row }">
                <div class="unsubscribe-reason" v-if="row.global_unsubscribe">
                    <span title="* contact is globally unsubscribed" class="label label-default"
                          v-if="row.reason_for_global_unsubscribe">{{ row.reason_for_global_unsubscribe }}</span>
                    <span title="* contact is globally unsubscribed" class="label label-default" v-else>Globally Unsubscribed</span>
                </div>
                <div class="unsubscribe-reason" v-else>
                    <span class="label label-default">{{ row.reason_for_unsubscribe }}</span>
                </div>
            </template>
            <template #actions="{ row }">
                <div class="d-flex justify-content-end">
                    <a
                        class="btn btn-primary mx-2"
                        :href="createContactEditUrl(row.id)"
                        title="Edit Contact"
                        v-tooltip="'Edit Contact'"
                    >
                        <i class="fas fa-fw fa-edit"></i>
                    </a>

                    <button
                        class="btn btn-danger mx-2"
                        title="Delete Contact"
                        v-tooltip="'Delete Contact'"
                        @click="onDeleteButtonClick($event, row)"
                    >
                        <i class="fas fa-fw fa-trash"></i>
                    </button>
                </div>
            </template>
        </snappy-table>

        <delete-contact-modal v-if="deletedContact" :contact="deletedContact"
                              @close-modal="onCloseDeleteModal"></delete-contact-modal>
    </div>
</template>

<script>
import SnappyTable from '../../components/SnappyTable';
import DeleteContactModal from '../contact/DeleteContactModal';
import columnTemplates from "../../mixins/tables/columnTemplates";
import {joinGroup} from '../../utility/api/group/joinGroup';
import {leaveGroup} from '../../utility/api/group/leaveGroup';

export default {
    name: 'group-membership-management-table',
    components: {SnappyTable, DeleteContactModal},
    mixins: [columnTemplates],
    methods: {
        handleGroupMemberships(row) {
            if (row.status === 'member') {
                this.handleStatusClick(row, 'neutral');
                leaveGroup(this.groupId, row.id);
                this.$emit('update-group-member-count', -1);
            } else if (row.status === 'group' || row.status === 'neutral') {
                this.handleStatusClick(row, 'member');
                joinGroup(this.groupId, row.id);
                this.$emit('update-group-member-count', 1);
            }
        },

        handleStatusClick(row, status) {
            row.status = status;

            setTimeout(() => {
                let els = document.getElementsByClassName('label-' + row.id);

                for (let i = 0; i < els.length; i++) {

                    if (typeof els[i] !== 'undefined') {
                        els[i].classList.remove('hoverable');
                    }
                }
            }, 50);

            setTimeout(() => {
                let els = document.getElementsByClassName('label-' + row.id);

                for (let i = 0; i < els.length; i++) {
                    els[i].addEventListener("mouseout", function handler(e) {
                        if (typeof els[i] !== 'undefined') {
                            els[i].classList.add('hoverable');
                        }

                        e.currentTarget.removeEventListener(e.type, handler);
                    });
                }
            }, 250);
        },

        onDeleteButtonClick(event, contact) {
            event.stopPropagation();
            this.deletedContact = contact;
        },

        onCloseDeleteModal() {
            this.deletedContact = null;
        },

        createContactEditUrl(contactId) {
            return '/inventory/contacts/edit/?sk_token=' + btoa('contact_id=' + contactId);
        }
    },
    data() {
        return {
            deletedContact: null,

            filterValues: {
                status: [
                    {'id': 'member', 'text': 'Member'}
                ]
            }
        };
    },
    props: {
        vesselId: {
            type: Number,
            required: true
        },
        groupId: {
            type: Number,
            required: true
        },
        clickToToggleParams: {
            type: Object,
            required: true
        },
        timezone: {
            type: String,
            required: true
        },
    }
}
</script>
